import { ClaimSparkRewardsDialogContentContainer } from './ClaimSparkRewardsContainer'
import { Token } from '@/domain/types/Token'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

export interface ClaimSparkRewardsDialogProps extends CommonDialogProps {
  tokensToClaim: Token[]
}

function ClaimSparkRewardsDialog({ open, setOpen, tokensToClaim }: ClaimSparkRewardsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <ClaimSparkRewardsDialogContentContainer tokensToClaim={tokensToClaim} closeDialog={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}

export const claimSparkRewardsDialogConfig: DialogConfig<ClaimSparkRewardsDialogProps> = {
  options: {
    closeOnAccountChange: true,
  },
  element: ClaimSparkRewardsDialog,
  name: 'ClaimSparkRewardsDialog',
}
